"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Fri Sep 21 2018
 */

var DataObjectConverter_1 = require("../../../core/conversions/DataObjectConverter");
/**
 * CompetitorProductDTOConverter
 *
 * @author RV
 */


var CompetitorProductDTOConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(CompetitorProductDTOConverter, _DataObjectConverter_);

  function CompetitorProductDTOConverter() {
    _classCallCheck(this, CompetitorProductDTOConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(CompetitorProductDTOConverter).apply(this, arguments));
  }

  return CompetitorProductDTOConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.CompetitorProductDTOConverter = CompetitorProductDTOConverter;